import { render, staticRenderFns } from "./TransactionConfirmationForm.vue?vue&type=template&id=cfff4300&"
import script from "./TransactionConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./TransactionConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports